// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__dJ7KF","rotation":"SmallLoader_rotation__3PPMi"};